export default __webpack_public_path__ + "static/3-7cb4bdbbf2152bb4822360390c235351.png";